<script lang="ts">
  import { ServicesTitle } from '../../components/icons/index';
  import { getHref } from '../../helpers/sections-helper';
  import BulletPoint from '../../components/BulletPoint.svelte';
  import './css/services2.scss';
  import type { Services } from '../types';
  import Swiper from 'swiper';
  import { Pagination, Navigation } from 'swiper/modules';
  import { onMount } from 'svelte';
  import 'swiper/css';
  import 'swiper/css/pagination';
  import 'swiper/css/navigation';

  export let properties: Services;

  $: ({ headline, items, button, callouts } = properties);

  let element: HTMLDivElement;

  onMount(() => {
    new Swiper(element, {
      modules: [Pagination, Navigation],
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1.1,
      centeredSlides: true,
      spaceBetween: 10,
      breakpoints: {
        697: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });
</script>

<section class="some-of-services">
  <div class="wrapper">
    <div class="why-top">
      <h2 class="h2">{@html headline.value}</h2>
      <ServicesTitle />
    </div>

    <div class="mt-10 w-full px-5 lg:px-20">
      <div class="container relative mx-auto">
        <div class="swiper services-slider" bind:this={element}>
          <div class="swiper-wrapper">
            {#each items as { description, image, title }}
              <div class="swiper-slide">
                <div class="stroke md:hidden" />
                <div class="why-us-card">
                  <div class="card-content-box">
                    {#if image}
                      <img
                        loading="lazy"
                        src={image.value}
                        alt="img"
                        class="mb-5 aspect-[4/3] w-full rounded-md object-cover"
                      />
                    {/if}
                    <div class="card-content">
                      <h3 class="h3 mb-3">{@html title.value}</h3>
                      <p class="text">
                        {@html description.value}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            {/each}
          </div>
          <br /><br />
          <div class="swiper-pagination" />
        </div>
        <div class="swiper-button-prev">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M13.2069 17.293L8.91394 13H18.4999V11H8.91394L13.2069 6.70697L11.7929 5.29297L5.08594 12L11.7929 18.707L13.2069 17.293Z"
              fill="#111111"
              fill-opacity="0.64"
            />
          </svg>
        </div>
        <div class="swiper-button-next">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M11.793 17.293L13.207 18.707L19.914 12L13.207 5.29297L11.793 6.70697L16.086 11H6.5V13H16.086L11.793 17.293Z"
              fill="#111111"
              fill-opacity="0.64"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="mx-auto">
      {#if button && button?.label?.length}
        <div class="bottom-boxes">
          <a
            class="primary-button open-form-js"
            target={button.link_type === 'External' ? '_blank' : ''}
            href={getHref(button.link_type, button.link)}
            >{@html button.label}</a
          >
          {#if callouts}
            <div class="small-text-box">
              {#each callouts.value as item}
                <div>
                  <BulletPoint bulletIcon={callouts.icon} />
                  <p class="text-small">{@html item}</p>
                </div>
              {/each}
            </div>
          {/if}
        </div>
      {/if}
    </div>
  </div>
</section>
